import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Modal from './Modal';
import Button from '@material-ui/core/Button';
import { withNamespaces } from 'react-i18next';
import combineStyles from '../../../utils/combineStyles';
import ButtonStyles from '../../../styles/button';
import ConfirmDialogStyles from './ConfirmDialog.styles';
import ProgressButton from '../Buttons/Progress';

export class ConfirmDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    confirmLabel: PropTypes.string.isRequired,
    cancelLabel: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onCancel: PropTypes.func, // This is optional to run if they click cancel button
    onConfirm: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool
  };

  render() {
    const {
      classes,
      open,
      title,
      message,
      confirmLabel,
      cancelLabel,
      onClose,
      onCancel,
      onConfirm,
      t,
      isSubmitting = false
    } = this.props;
    const handleOnCancel = onCancel ? onCancel : onClose;
    return (
      <Modal
        open={open}
        onClose={onClose}
        classes={{
          root: classes.modalRoot,
          footer: classes.modalFooter
        }}
        body={
          <Fragment>
            <p className={classes.formTitle}>{title}</p>
            <p className={classes.formSubTitle}>{message}</p>
          </Fragment>
        }
        footer={
          <Fragment>
            <Button
              color={'primary'}
              className={classes.textButton}
              onClick={handleOnCancel}
            >
              {cancelLabel ? cancelLabel : t('Cancel')}
            </Button>
            <ProgressButton
              onClick={onConfirm}
              className={classes.textButton}
              color={'primary'}
              disabled={isSubmitting}
              isSubmitting={isSubmitting}
            >
              {confirmLabel}
            </ProgressButton>
          </Fragment>
        }
      />
    );
  }
}
const translatedConfirmDialog = withNamespaces()(ConfirmDialog);
export default withStyles(combineStyles(ConfirmDialogStyles, ButtonStyles))(
  translatedConfirmDialog
);
